import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../../../../services/api";
import VariantButton from "../../../../components/variant-button/variant-button";

export default function AddUser() {
  const [permissions, setPermissions] = useState(undefined);
  useEffect(() => {
    fetchPermissions();
  }, []);

  const fetchPermissions = async () => {
    try {
      const res = await api.get("/users/permissions");
      setPermissions(res.data.data);
    } catch (error) {}
  };

  const [form, setForm] = useState({
    fullName: "",
    email: "",
    password: "",
    phoneNumber: "",
    gender: "",
    role: "",
  });
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [roleChecks, setRoleChecks] = useState([]);

  useEffect(() => {
    fetchRoles();
  }, []);

  const fetchRoles = async () => {
    try {
      const res2 = await api.get("/users/roles");
      setRoleChecks(res2.data.data);
    } catch (error) {}
  };

  const handleSubmit = async () => {
    try {
      if (
        !form.email ||
        !form.fullName ||
        !form.password ||
        !form.phoneNumber ||
        !form.gender ||
        !form.role ||
        form.role.length === 0
      ) {
        setError("Vui lòng điền đầy đủ tất cả các trường.");
        return;
      }
      await api.post("/users", {
        fullName: form.fullName,
        email: form.email,
        password: form.password,
        phoneNumber: form.phoneNumber,
        gender: form.gender,
        role: form.role,
      });
      navigate("/users");
    } catch (error) {
      console.error("Error creating user:", error);
      setError("Không thể tạo người dùng. Vui lòng thử lại.");
    }
  };

  return (
    permissions &&
    permissions.includes("users.create") && (
      <div className="flex-1 overflow-y-auto p-6 bg-gray-100 min-h-screen">
        <div className="w-full mx-auto">
          <h1 className="text-3xl font-bold text-gray-800 mb-6">
            Quản lý Người dùng
          </h1>
          <div className="bg-white shadow-xl rounded-lg p-6">
            <h2 className="text-2xl font-semibold text-gray-700 mb-4">
              Thêm Người dùng
            </h2>
            {error && (
              <div className="relative">
                <p className="bg-red-500 text-white p-2 mb-4 rounded-md shadow">
                  {error}
                </p>
                <button
                  onClick={() => setError("")}
                  className="absolute right-3 top-1 text-white text-xl hover:text-gray-200 active:translate-y-1"
                >
                  &times;
                </button>
              </div>
            )}
            <div className="space-y-4">
              <input
                type="text"
                placeholder="Họ và tên"
                value={form.fullName}
                onChange={(e) => setForm({ ...form, fullName: e.target.value })}
                className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <input
                type="email"
                placeholder="Email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <input
                type="password"
                placeholder="Mật khẩu"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <input
                type="text"
                placeholder="Số điện thoại"
                value={form.phoneNumber}
                onChange={(e) =>
                  setForm({ ...form, phoneNumber: e.target.value })
                }
                className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <select
                value={form.gender}
                onChange={(e) => setForm({ ...form, gender: e.target.value })}
                className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="" disabled>
                  Chọn giới tính
                </option>
                <option value="male">Nam</option>
                <option value="female">Nữ</option>
                <option value="other">Khác</option>
              </select>
              {roleChecks.map((item) => (
                <div className="flex flex-row space-x-2 items-center hover:underline">
                  <input
                    id={item.code}
                    type="checkbox"
                    checked={(form.role || []).some(
                      (_item) => _item.id === item.id,
                    )}
                    onChange={(e) => {
                      setForm((prev) => {
                        const currentRoles = Array.isArray(prev.role)
                          ? prev.role
                          : [];

                        const newRoles = e.target.checked
                          ? [...currentRoles, item]
                          : currentRoles.filter((role) => role.id !== item.id);

                        return {
                          ...prev,
                          role: newRoles,
                        };
                      });
                    }}
                  />

                  <label for={item.code} className="cursor-pointer">
                    {item.name}
                  </label>
                </div>
              ))}

              <div className="flex space-x-3 justify-end">
                <div className="w-[120px]">
                  <VariantButton
                    props={{
                      onClick: handleSubmit,
                      title: "Tạo",
                    }}
                  />
                </div>
                <div className="w-[120px]">
                  <Link to={"/users"}>
                    <VariantButton
                      props={{
                        onClick: null,
                        title: "Trở lại",
                      }}
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
}
